<div class="c-slat__content c-vacatures-widget__slat" [ngClass]="isAfgesloten() ? '-closed' : ''">
  <div class="c-vacatures-widget__slat-title">
    <strong class="c-vacatures-widget__slat-status">
      {{ getStatus() }}
      @if (heeftDatumIngevuld()) {
        <span class="c-vacatures-widget__slat-status-extra -date">
          {{ getToekomstigGepubliceerdMededeling() }}{{ getPublicatieInformatieVanTot() }}
        </span>
      }
    </strong>
    <h3 class="u-mt0 u-mb0 h4">
      <a href="/vac/openVacature.do?id={{vacature.vacatureId}}"
         class="u-text-decoration-none u-mr05">{{ vacature.functieNaam }}</a>
      @if (vacature.isBemiddeld) {
        <span
            class="c-vacatures-widget__VDAB-beheer c-tag -info -light">VDAB zoekt kandidaten</span>
      }
    </h3>
    @if (heeftOla()) {
      <span>
        <span class="c-vacatures-widget__alert" [ngClass]="bepaalOlaNiveau()">
          <span class="c-vacatures-widget__alert-text">{{ bepaalOlaType() }}</span>
          @if (heeftMeerInfo()) {
            <a class="c-vacatures-widget__alert-link"
               href="/vac/openVacature.do?id={{vacature.vacatureId}}">Meer info.</a>
          }
        </span>
      </span>
    }
  </div>
  <ul class="u-reset-list c-vacatures-widget__vacstats">
    <li class="c-vacatures-widget__stat-container">
      <div class="c-vacatures-widget__stat-number"
           id="aantalKeerVerzonden-{{vacature.vacatureId}}">{{ vacature.statistieken.verzonden }}
      </div>
      <div class="c-vacatures-widget__stat-label">verzonden</div>
    </li>
    <li class="c-vacatures-widget__stat-container">
      <div class="c-vacatures-widget__stat-number"
           id="aantalKeerBekeken-{{vacature.vacatureId}}">{{ vacature.statistieken.bekeken }}
      </div>
      <div class="c-vacatures-widget__stat-label">bekeken</div>
    </li>
  </ul>
</div>
